__turbopack_context__.v({
  "clampedWidthWrapper": "Vgj7IW_clampedWidthWrapper",
  "wrapper": "Vgj7IW_wrapper",
});
